var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDottedpatterne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 322 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666D93",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 101,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 111,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 121,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 131,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 141,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 151,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 171,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 201,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 211,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 241,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 251,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 261,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 271,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 281,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 291,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 301,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 321,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 331,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedpatterne);
export default __webpack_public_path__ + "static/media/dottedpatterne.4af44c70ae22f832766b8c4389bc4990.svg";
export { ForwardRef as ReactComponent };